module.exports = __webpack_public_path__ + "static/media/20170129_120907.3678f501.jpg";